import { render, staticRenderFns } from "./BaseButtonSmall.vue?vue&type=template&id=ee75f7c2&scoped=true"
import script from "./BaseButtonSmall.vue?vue&type=script&lang=js"
export * from "./BaseButtonSmall.vue?vue&type=script&lang=js"
import style0 from "./BaseButtonSmall.vue?vue&type=style&index=0&id=ee75f7c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee75f7c2",
  null
  
)

export default component.exports